import { render } from "./WhereToBuy.vue?vue&type=template&id=40dfee2b&scoped=true"
import script from "./WhereToBuy.vue?vue&type=script&lang=js"
export * from "./WhereToBuy.vue?vue&type=script&lang=js"

import "./WhereToBuy.vue?vue&type=style&index=0&id=40dfee2b&scoped=true&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dfee2b"]])

export default __exports__